import { Component, Inject, NgZone, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { InteractionStatus, InteractionType, AuthenticationResult, PopupRequest, RedirectRequest, EventMessage, EventType } from '@azure/msal-browser';
import { UserDetail, UserService } from './modules/shared/user.service';
import { filter, firstValueFrom, Subject, Subscription, take, takeUntil } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import * as fromModel from './modules/shared/models';
import { HttpService } from './modules/shared/http.service';
import { Utils } from './modules/shared/utils';
import { Constant } from './modules/shared/constants';
// Corrected import path or ensure the file exists
import * as fromModels from './modules/shared/models';
import { MatMenuTrigger } from '@angular/material/menu';
import { InitService } from './modules/shared/init.service';
import { AdvisorService } from './modules/shared/advisors-tree-filter/advisor.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.scss'
})
export class AppComponent {
  isIframe = false;
  private readonly _destroying$ = new Subject<void>();
  private hasLoadedAdvisorTree = false;
  isFirstTimeLoggedin = false;
  jwtHelperSvc: JwtHelperService | undefined;
  loggedIn: boolean = false;
  _urlSub?: Subscription;
  user: UserDetail | undefined;

  loggedInUser: UserDetail | undefined;
  simRole: fromModels.USERROLE | any;
  orgRole: fromModels.USERROLE | any;
  tempRole: fromModels.USERROLE | any;
  isVisibleRoleSelection=true;
  isDivisionSelection=true;
  showProgress = false;
  runMessage:string='';
  repIds: string[]=[];
  @ViewChild('advMenuTrigger') advMenuTrigger: MatMenuTrigger | undefined;
  advTree: fromModels.TodoItemNode[] = [];


  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private msalBroadcastService: MsalBroadcastService,
    private authService: MsalService,
    private router: Router,
    private userService: UserService,
    private ngZone: NgZone,
   
    private _advisor:AdvisorService,
  
  ) {

    this.isIframe = window !== window.parent && !window.opener;

    this._urlSub = router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // * change of route detected
       
      }
    });
  }


  ngOnInit() {
    

    this.userService.traceMsg("******** Supervision - App - Init ********");
    this.isIframe = window !== window.parent && !window.opener;

    // this.authService.acquireTokenSilent({
    //   scopes: ['https://supervision.dev/default'], // Replace with your required scopes
    // }).subscribe({
    //   next: (tokenResponse) => {
    //     console.log('Token Response:', tokenResponse);
    //   },
    //   error: (error) => {
    //     console.error('Token Acquisition Error:', error);
    //   },
    // });



    
  
     

  

    

    this.authService.handleRedirectObservable()
      .pipe(takeUntil(this._destroying$))
      .subscribe({
        next: (result: AuthenticationResult | null) => {
          this.ngZone.run(() => {
            if (result?.account) {
              this.authService.instance.setActiveAccount(result.account);
              this.afterAuthSuccess(result);
            }
          });
        },
        error: (error) => console.error('MSAL redirect error:', error)
      });

    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) =>
          msg.eventType === EventType.LOGIN_SUCCESS ||
          msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
          msg.eventType === EventType.LOGOUT_SUCCESS
        ),
        takeUntil(this._destroying$)
      )
      .subscribe((result) => {
        this.ngZone.run(() => {
          if (result.eventType === EventType.LOGOUT_SUCCESS) {
            this.loggedIn = false;
            return;
          }

          if (result.eventType === EventType.LOGIN_SUCCESS || result.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) {
            const payload = result.payload as AuthenticationResult;
            if (payload?.account) {
              this.authService.instance.setActiveAccount(payload.account);
            }
            this.afterAuthSuccess(payload);
          }
        });
      });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status) => status === InteractionStatus.None),
        take(1)
      )
      .subscribe(() => {
        this.ngZone.run(() => {
          const active = this.authService.instance.getActiveAccount();
          if (!active) {
            const accounts = this.authService.instance.getAllAccounts();
            if (accounts.length > 0) {
              this.authService.instance.setActiveAccount(accounts[0]);
              this.loggedIn = true;
              this.getUserNameFromSession();
              this.loadAdvisorTreeOnce();
            } else {
              this.login();
            }
            return;
          }

          this.loggedIn = true;
          this.getUserNameFromSession();
          this.loadAdvisorTreeOnce();
        });
      });


     


      // this.checkAccount();
      // if (!this.loggedIn) {
      //   this.login();
      // } else {
      //   this.getUserName(localStorage.getItem('msal.idtoken') ?? '');
      // }
    
    }

      private afterAuthSuccess(payload: AuthenticationResult) {
        if (payload.idToken) {
          sessionStorage.setItem('msal.idtoken', payload.idToken);
          this.userService.traceMsg('Supervision UI: idtoken: ' + payload.idToken);
        }

        if (!this.isFirstTimeLoggedin) {
          this.isFirstTimeLoggedin = true;
          if (payload.idToken) {
            this.getUserName(payload.idToken);
          } else {
            this.getUserNameFromSession();
          }
          this.loadAdvisorTreeOnce();
        }

        this.loggedIn = true;
      }

      private loadAdvisorTreeOnce() {
        if (this.hasLoadedAdvisorTree) {
          return;
        }

        this.hasLoadedAdvisorTree = true;
        this.divisionPopulation();
      }


        
divisionPopulation(){

  this._advisor
  .getAdvisors(
    this.loggedInUser?.role === fromModels.USERROLE.BM
      ? this.loggedInUser.userid
      : '',
    this.loggedInUser?.role === fromModels.USERROLE.FA ? true : false
  )
  .subscribe({
    next: (adv: fromModels.AdvisorHirerarchy) => {
      if (adv && adv.regions && adv.regions.length) {
        this.prepareAdvisorsTree(adv);
      }
    },
    error: (err) => {
      this.userService.traceMsg(
        'PeriodicClientReview -> Error getting advisors data.',
        err,
        'Error'
      );
    },
  });
}


    private prepareAdvisorsTree(adv: any) {
      let advisorsTreeData: any[] = [];
      let id = 1;
      let code = '0.1';
      this.advTree = [];
      //regions
      adv.regions.forEach((r: any) => {
        let region = {
          text: r.regName,
          code: code.toString(),
          isChecked: false,
          id: 'R' + id.toString(),
          color: '#004377',
        };
        advisorsTreeData.push(region);
        id++;
  
        //hubs
        r.hubs.forEach((h: any, hi: any) => {
          let hub = {
            text: h.hubName,
            code: `${code.toString()}.${hi + 1}`,
            isChecked: false,
            id: 'H' + id.toString(),
            color: '#5c60b7',
          };
          advisorsTreeData.push(hub);
          id++;
  
          //teams
          h.teams.forEach((t: any, ti: any) => {
            let team = {
              text: t.teamName,
              code: `${hub.code}.${ti + 1}`,
              isChecked: false,
              id: 'T' + id.toString(),
              color: '#8A39E1',
            };
            advisorsTreeData.push(team);
            id++;
  
            //advisors
            t.advisors.forEach((a: any, ai: any) => {
              let advisor = {
                text: `${a.repId} - ${a.repName}`,
                code: `${team.code}.${ai + 1}`,
                isChecked: false,
                id: a.repId,
                color: 'black',
              };
              advisorsTreeData.push(advisor);
              id++;
            });
          });
        });
        code = (Number(code) + 0.1).toFixed(1);
      });
      this.advTree = advisorsTreeData;
    }

    closeAdvTree() {
      if (this.advMenuTrigger) {
        this.advMenuTrigger.closeMenu();
      }
    }

    advListChanged(_repIds: string[]) {
      this.repIds = _repIds;
      
  
     
      this.closeAdvTree();
    }


      ngOnDestroy() {
       // this._urlSub?.unsubscribe();
        this._destroying$.next(undefined);
        this._destroying$.complete();
      }
    
      checkAccount() {
        this.loggedIn = this.authService.instance.getAllAccounts().length > 0;
        if (this.loggedIn) {
          this.getUserNameFromSession();
        }
      }
    
      login(scopes: string[] = Constant.config.scopes) {
        if (this.isIframe) {
          this.authService.instance.ssoSilent({ scopes })
            .catch(() => firstValueFrom(this.authService.loginPopup({ scopes } as PopupRequest)));
        } else {
          this.authService.loginRedirect({ scopes } as RedirectRequest);
        }
      }
    
      logout() {
        this.authService.logoutRedirect();
      }
    
    
    
    
    
      private getRole(roles: string[]) {
        console.log(this.router.url)
        let role = fromModel.USERROLE.FA;
        if (roles && roles.length > 0) {
          let r: any;
          console.log('R', roles);
          r = roles.find(_role => _role === "RCM.PMTECH");
          if (r !== undefined) {
            role = fromModel.USERROLE.SUPER;
            return role;
          }
          r = roles.find(_role => _role === "Advisory.ADBD");
          if (r !== undefined) {
            role = fromModel.USERROLE.BM;
            return role;
          }
    
          r = roles.find(_role => _role === "Advisory.Compliance");
          if (r !== undefined) {
            role = fromModel.USERROLE.COMP;
            return role;
          }
    
    
    
    
          r = roles.find(_role => _role === "Advisory.HomeOffice");
          if (r !== undefined) {
            role = fromModel.USERROLE.HO;
            return role;
          }
    
          r = roles.find(_role => _role === "Advisory.Supervision");
          if (r !== undefined) {
            role = fromModel.USERROLE.SUPERVISION;//Supervision is tagged as HO
            return role;
          }
    
          r = roles.find(_role => _role === "Advisory.OLT");
          if (r !== undefined) {
            role = fromModel.USERROLE.BM;
            return role;
          }
    
          r = roles.find(_role => _role === "Advisory.All");
          if (r !== undefined) {
            role = fromModel.USERROLE.FA;
            return role;
          }
        }
        return role;
      }
    
    
      private getUserName(idtoken: string) {
        if (!this.jwtHelperSvc) {
          this.jwtHelperSvc = new JwtHelperService();
        }
        if (idtoken) {
          const decodedToken = this.jwtHelperSvc.decodeToken(idtoken);
          if (!this.userService.getUser()) {
            console.log("***********************************GET USER NAME****************************");
            let _u = new UserDetail();
            _u.name = decodedToken.name || '';
            _u.userid = decodedToken.preferred_username || '';
            _u.poolIds = decodedToken.poolIds || '';
            _u.repId = decodedToken.primaryid || '';
    
            if (decodedToken.roles) {
              console.log("Roles: " + JSON.stringify(decodedToken.roles));
              this.userService.traceMsg("Supervision UI. Roles: " + JSON.stringify(decodedToken.roles));
            } else {
              this.userService.traceMsg("Supervision UI: Roles not found");
            }
    
            this.userService.traceMsg("Supervision UI: name: " + _u.name + " T:" + idtoken);
    
            _u.role = this.getRole(decodedToken?.roles);
            this.initUser(_u);
    
         
    
          }
        }
      }
       private getUserNameFromSession() {
        const idtoken = sessionStorage.getItem('msal.idtoken');
        if (!this.jwtHelperSvc) {
          this.jwtHelperSvc = new JwtHelperService();
        }
        if (idtoken) {
          const decodedToken = this.jwtHelperSvc.decodeToken(idtoken);
          if (!this.userService.getUser()) {
            console.log("***********************************GET USER NAME****************************");
            let _u = new UserDetail();
            _u.name = decodedToken.name || '';
            _u.userid = decodedToken.preferred_username || '';
            _u.poolIds = decodedToken.poolIds || '';
            _u.repId = decodedToken.primaryid || '';
    
            if (decodedToken.roles) {
              console.log("Roles: " + JSON.stringify(decodedToken.roles));
              this.userService.traceMsg("Supervision UI. Roles: " + JSON.stringify(decodedToken.roles));
            } else {
              this.userService.traceMsg("Supervision UI: Roles not found");
            }
    
            this.userService.traceMsg("Supervision UI: name: " + _u.name + " T:" + idtoken);
    
            _u.role = this.getRole(decodedToken?.roles);
            this.initUser(_u);
    
         
    
          }
        }
      }
    
      private initUser(_u: UserDetail) {
        this.user = _u;
        this.userService.setUser(_u);
      }




      //// fOR ui

      get showUserSel() {
        if (Constant.config.env === 'QA' || Constant.config.env === 'DEV') {
          return (
            this.orgRole !== fromModels.USERROLE.FA &&
            this.orgRole !== fromModels.USERROLE.BM
          );
        } else if (Constant.config.env === 'PROD') {
          return this.orgRole === fromModels.USERROLE.SUPER;
        } else {
          return false;
        }
      }
      
      
      changeUser() {
        this.simRole = this.tempRole;
        let role: fromModels.USERROLE;
        if ((this.simRole as any) === 'CONTROL') {
          role = fromModels.USERROLE.SUPERVISION;
        } else {
          role = this.simRole;
        }
        
        //  this.getPeriodicClientData();
        //this.annualReviewService.setRole(role);
      }
    
}
